import React, { useEffect } from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Modal, Row, Col, Table } from "react-bootstrap";
import { Button, Loading } from "@src/components/atoms";
import { useAlert } from "react-alert";

const OrderTrackingModal: React.FC<IProps> = (
  {
    show,
    onHide,
    trackingData,
    loading,
    isError,
    tracking_url,
    awb
  }: IProps) => {
  const alert = useAlert();

  const handleAwbClick = () => {
    // clipboard 복사
    const t = document.createElement('textarea');
    document.body.appendChild(t);
    t.value = awb;
    t.select();
    document.execCommand('copy');
    document.body.removeChild(t);
    alert.success('AWB is copied to the clipboard.')

    // url 새창 열기
    window.open(tracking_url);
  }

  return (
    <S.Wrapper>

      <Modal
        show={show}
        onHide={onHide}
        size="lg"
      >
        <Modal.Header closeButton>

        </Modal.Header>
        <Modal.Body>
          {loading ? <Loading />
            : isError ? tracking_url ? <div onClick={handleAwbClick}><h2>You can track from courier website</h2><a href='#'>{tracking_url}</a><p>{awb}</p>
                  <p>Tap here to visit courier's website. Also AWB information will be copied to your clipboard.</p></div>
                :
                <p>Unable to find tracking information. Please contact to livechat.</p>
              :
              <Table>
                <thead>
                <tr>
                  <th>Date time</th>
                  <th>Location</th>
                  <th>Comments</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                {trackingData.map((data, idx) => {
                  const d = new Date(data.datetime);
                  const tz = d.toLocaleString("en-US", { timeZone: "Asia/Kolkata" });
                  return (
                    <tr key={idx}>
                      <td>{tz}</td>
                      <td>{data?.location ?? ""}</td>
                      <td>{data?.comments ?? ""}</td>
                      <td>{data?.status ?? ""}</td>
                    </tr>
                  );
                })}
                </tbody>
              </Table>
          }

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide}>close</Button>
        </Modal.Footer>
      </Modal>

    </S.Wrapper>
  );
};

export { OrderTrackingModal };